


























import { Component, Vue } from "vue-property-decorator";

@Component
export default class App extends Vue {
  drawer = false;
  items = [
    {
      title: "Home",
      to: "/"
    },
    {
      title: "About",
      to: "/about"
    },
    {
      title: "Manufacturers",
      to: "manufacturers"
    }
  ];
}
